import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import * as React from 'react';

import CruisePurchaseGuestDetailTable from './item-table';

export default function CruisePurchaseItemDetailTable({
  parentIndex,
}: {
  parentIndex: number;
}) {
  const _values = HOCWatchValue({
    keys: [`approvalable.cruisePurchases.${parentIndex}`],
  });
  const { isGroupedPrice, cruisePurchaseGuests } =
    _values[`approvalable.cruisePurchases.${parentIndex}`];

  if (!cruisePurchaseGuests.length) {
    return <></>;
  }

  if (isGroupedPrice) {
    return (
      <CruisePurchaseGuestDetailTable
        guestIndex={0}
        parentIndex={parentIndex}
      />
    );
  }

  return (
    <>
      {cruisePurchaseGuests.map((field, idx) => (
        <React.Fragment key={field.id}>
          <Separator gap={24} />
          <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
          <Separator gap={16} />
          <CruisePurchaseGuestDetailTable
            guestIndex={idx}
            parentIndex={parentIndex}
          />
        </React.Fragment>
      ))}
    </>
  );
}
